import axiosInstance from '@/setup/axios/axiosInstance';
import type { InventoryItemOption } from '../models/ItemModel';

interface UnitApiItem {
  id: string | number;
  code?: string;
  name?: string;
  title?: string;
}

const unwrapListData = (data: any): UnitApiItem[] => {
  if (Array.isArray(data)) {
    return data;
  }

  if (Array.isArray(data?.results)) {
    return data.results;
  }

  return [];
};

export const getItemUomBackendOptions = async (): Promise<Array<{ id: string; name: string }>> => {
  const response = await axiosInstance.get('/inventory/units/', { params: { pagination: 'false' } });
  const items = unwrapListData(response.data);

  return items.map((item) => ({
    id: String(item.id),
    name: item.name || item.title || item.code || String(item.id),
  }));
};

export const toCompanyScopedUomOptions = (items: Array<{ id: string; name: string }>, companyId: string): InventoryItemOption[] => {
  return items.map((item) => ({
    id: item.id,
    name: item.name,
    company_id: companyId,
  }));
};

export const createItemUomBackend = async (
  name: string,
  conversion?: { to_uom_id: string; ratio: number },
): Promise<{ id: string; name: string }> => {
  const payload: Record<string, string | number> = {
    name: name.trim(),
  };

  if (conversion?.to_uom_id && conversion.ratio > 0) {
    payload.to_uom_id = conversion.to_uom_id;
    payload.ratio = conversion.ratio;
  }

  const response = await axiosInstance.post('/inventory/units/', payload);
  const item = response.data;

  return {
    id: String(item.id),
    name: item.name || item.code || String(item.id),
  };
};
